export const HomePageExplore =[
    {
        tag: 'Free',
        courses : [
            {
                "heading": "Learn HTML",
                "description": "Understand the structure of web pages with HTML tags and elements.",
                "level": "Beginner",
                "lessonNumber": 12
            },
            {
                "heading": "Learn CSS",
                "description": "Style websites with layouts, colors, and responsive design.",
                "level": "Beginner",
                "lessonNumber": 15
            },
            {
                "heading": "Responsive Web Design",
                "description": "Make your sites look great on all devices.",
                "level": "Intermediate",
                "lessonNumber": 10
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                "heading": "Introduction to Programming",
                "description": "Start your coding journey with basic concepts and logic building.",
                "level": "Beginner",
                "lessonNumber": 8
            },
            {
                "heading": "Python Basics",
                "description": "Learn variables, loops, and functions in Python.",
                "level": "Beginner",
                "lessonNumber": 14
            },
            {
                "heading": "JavaScript for Beginners",
                "description": "Get started with programming for the web.",
                "level": "Beginner",
                "lessonNumber": 12
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                "heading": "React.js Fundamentals",
                "description": "Build interactive UIs using components and hooks.",
                "level": "Intermediate",
                "lessonNumber": 18
            },
            {
                "heading": "JavaScript Mastery",
                "description": "Deep dive into modern JavaScript and real-world projects.",
                "level": "Intermediate",
                "lessonNumber": 20
            },
            {
                "heading": "Python for Data Science",
                "description": "Use Python for analysis, visualization, and machine learning.",
                "level": "Intermediate",
                "lessonNumber": 22
            },
        ]
    },
    {
        tag: 'Skill paths',
        courses : [
            {
                "heading": "Frontend Development",
                "description": "Master HTML, CSS, and JavaScript to build web apps.",
                "level": "Intermediate",
                "lessonNumber": 30
            },
            {
                "heading": "Backend Development",
                "description": "Learn Node.js, Express, and databases for backend systems.",
                "level": "Intermediate",
                "lessonNumber": 28
            },
            {
                "heading": "UI/UX Design Basics",
                "description": "Design user-friendly and visually appealing websites.",
                "level": "Beginner",
                "lessonNumber": 15
            },
        ]
    },
    {
        tag: 'Career paths',
        courses: [
            {
                "heading": "Full Stack Developer",
                "description": "Learn frontend + backend and build complete applications.",
                "level": "Advanced",
                "lessonNumber": 40
            },
            {
                "heading": "Data Scientist",
                "description": "Work with big data, analytics, and machine learning.",
                "level": "Advanced",
                "lessonNumber": 35
            },
            {
                "heading": "DevOps Engineer",
                "description": "Automate deployments and manage infrastructure.",
                "level": "Advanced",
                "lessonNumber": 25
            },
        ]
    }
]